// extracted by mini-css-extract-plugin
module.exports = {"cover":"Cover_cover__mDbKL","layout":"Cover_layout__Q_xro","row":"Cover_row__3_Nzw","title":"Cover_title__tV_hE"};